import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import app from '../../services/firebase';

const TopNavbar = () => {
  const navigate = useNavigate();
  const auth = getAuth(app);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <nav className="top-navbar">
      <ul className="nav-links">
        <li onClick={() => navigate('/main')}>Main Page</li>
        <li onClick={() => navigate('/profile')}>Profile</li>
        <li onClick={() => navigate('/data-input')}>Data Input</li>
        <li onClick={() => navigate('/stats')}>Stats</li>
        <li className="logout-button" onClick={handleLogout}>
          Logout
        </li>
      </ul>
    </nav>
  );
};

export default TopNavbar;